<template>
  <div class="scaleline-10">
    <div v-for="ind in 10" :key="ind" class="item-block" :style="{background: getItemColor(ind-1, false), borderColor: color}">
      <div v-if="ind-1 === valueFloor" class="item-block-fill" :style="{width: fillWidth, background: getItemColor(ind-1, true) }" />
      <span v-if="ind-1 === valueFloor || (ind===10 && valueFloor===10)" class="item-block-value">
        {{ valueShow }}
      </span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { rgbToHsl, hslToRgb, hexToRgb } from '@/common/util'

export default {
  props: {
    color: String,
    value: Number,
  },
  components: {
  },
  data() {
      return {
      };
  },
  computed: {
    lightColor() {
      return this.color + '30'
    },
    valueShow() {
      return Math.round(this.value)
    },
    fillWidth() {
      // return '100%'
      const v = (this.value10 - this.valueFloor) * 100
      return (v<10 ? 10: v) + '%'
    },
    value10() {
      return this.value / 10
    },
    valueFloor() {
      return Math.floor(this.value10)
    },
  },
  methods: {
    getItemColor(ind, isForeground) {
      return ind < this.valueFloor || isForeground ? this.getGradientColorByIndex(ind, true) : this.lightColor
    },

    getGradientColorByIndex(index, reverse) {
      const baseColor = hexToRgb(this.color);
      const total = this.valueFloor

      const [h, s, baseL] = rgbToHsl(...baseColor);
      const maxDelta = 25; // максимальное снижение яркости (в процентах)
      const step = maxDelta / (total+1);

      const startL = reverse ? Math.max(0, baseL + (total-index) * step) : Math.max(0, baseL + index * step);
      const endL = reverse ? Math.max(0, baseL + (total-index + 1) * step) : Math.max(0, baseL + (index + 1) * step);

      const startColor = hslToRgb(h, s, startL);
      const endColor = hslToRgb(h, s, endL);
      return `linear-gradient(to left, ${startColor}, ${endColor})`;
    },
  },
};
</script>


<style scoped lang="scss">
@import "src/assets/styles/variables";

.scaleline-10 {
  display: flex;
  width: 100%;
}

.scaleline-10 .item-block {
  width: 31px;
  height: 32px;
  border: 1px solid #fff;
  border-radius: 5px;
  flex: 31px 0 0;
  color: #000;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1px;
}

.item-block-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  opacity: 1;
}

.item-block-value {
  z-index: 10;
  font-weight: 600;
}

@media screen and (max-width: 800px) {
  .scaleline-10 .item-block {
      width: 16px;
      flex: 16px 0 0;
      height: 16px;
      border-radius: 3px;
  }
  .scaleline-10 .item-block-value {
      font-size: 10px;
  }
}

</style>
